import React from "react";
import { Box, useTheme } from "@mui/material";
import Button from "components/basic/button";
import { FormPageAction } from "../../types";

interface FormPageActionsProps {
  backAction?: FormPageAction;
  primaryAction?: FormPageAction;
  maxWidth: number;
}

const FormPageActions: React.FC<FormPageActionsProps> = ({
  backAction,
  primaryAction,
  maxWidth,
}) => {
  const theme = useTheme();

  if (!backAction && !primaryAction) {
    return null;
  }

  const renderButton = (action: FormPageAction) => (
    <Button
      variant="contained"
      color={action.color}
      size="large"
      style={{
        color: theme.palette.common.white,
        fontWeight: "bold",
      }}
      sx={{
        fontSize: { xs: "1rem", sm: "1.2em" },
        px: { xs: 2, sm: 4.5 },
        // Split the row evenly on phones so two buttons cannot overflow it.
        flex: { xs: "1 1 0", sm: "0 0 auto" },
      }}
      onClick={action.onClick}
      disabled={action.disabled}
    >
      {action.label}
    </Button>
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        flexShrink: 0,
        width: "100%",
        maxWidth,
        alignSelf: "center",
        gap: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: { xs: theme.spacing(3), md: theme.spacing(4) },
      }}
    >
      {backAction ? renderButton(backAction) : null}
      {primaryAction ? renderButton(primaryAction) : null}
    </Box>
  );
};

export default FormPageActions;
